import { useState } from "react";

function CopyableInput({ settings }) {
  const [copied, setCopied] = useState(false);

  console.log(settings)
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(settings?.upi_id || "");
      setCopied(true);
      setTimeout(() => setCopied(false), 1500); // Reset after 1.5s
    } catch (err) {
      console.error("Copy failed:", err);
    }
  };

  return (
   <div className="relative w-full max-w-sm">
  <input
    className="amount-input text-center w-full pr-10 border-0" // padding-right for icon space
    type="text"
    placeholder="Enter UTR Number"
    value={settings?.upi_id}
    readOnly
    style={{fontSize: "18px"}}
  />
  <span
    className="absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer text-blue-500 hover:text-blue-700"
    onClick={async () => {
      try {
        await navigator.clipboard.writeText(settings?.upi_id || "");
        alert("Copied!");
      } catch (err) {
        console.error("Failed to copy:", err);
      }
    }}
    title="Copy"
  >
    📋
  </span>
</div>

  );
}

export default CopyableInput;
